import { render, staticRenderFns } from "./SubscriptionOrderContainer.vue?vue&type=template&id=5b19f854&scoped=true&"
import script from "./SubscriptionOrderContainer.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionOrderContainer.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionOrderContainer.vue?vue&type=style&index=0&id=5b19f854&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b19f854",
  null
  
)

export default component.exports